export default __webpack_public_path__ + "Mask-group-12.6239dd.svg";